(function() {
	'use strict';

	angular.module('quantixApp').factory('userupdatedataService', userupdatedataService);

	userupdatedataService.$inject = [ '$http', '$q' ];
	function userupdatedataService($http, $q) {

		var _getUserPortfolio = function(portfolioId) {
			var deferred = $q.defer();
			var url = 'api/portfolio/getUserDataPortfolio';
			$http.post(url, portfolioId).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		
		
		return {
			getUserPortfolio : _getUserPortfolio
		
		};
	}
})();
